import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_af7f858f: FaireBrandEntity = {
  token: "b_af7f858f",
  type: "brand",
  name: "Ofina Jewelry",
  avatarUrl:
    "https://cdn.faire.com/fastly/7b142c753fd5b2f633e961947e84f0bf5cdbba97ade2dc1209b2b9bc44a2e608.jpeg",
  bannerUrl:
    "https://cdn.faire.com/fastly/d4c073a0a8b93fae2d71bfcbc334a78c4530eac8d87beb3a0b52ccb7df42b5f0.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/7b142c753fd5b2f633e961947e84f0bf5cdbba97ade2dc1209b2b9bc44a2e608.jpeg",
  heroImageUrl:
    "https://cdn.faire.com/fastly/d4c073a0a8b93fae2d71bfcbc334a78c4530eac8d87beb3a0b52ccb7df42b5f0.jpeg",
  location: "San Francisco, CA, USA",
  minimumOrderDollars: 200,
  rating: 4.8,
  reviewCount: 28,
  isInsider: true,
  description:
    "OFINA is a jewelry line that bursts forth an array of styles inspired by dainty, simple, classic taste.  Liza Anongchanya, is the proud female and minority owner since 2006.  In 2011 she opened her flagship boutique, Azil in San Francisco where her  jewelry line OFINA is showcased along with other independent designers. We pride ourselves on small batch, limited collections that is easy to wear from day to night.  At work or at play, OFINA jewelry accentuates a woman's individual style and mood without overdoing it.",
  meta: {
    source: "api",
    importedAt: "2026-07-23T05:56:07.483Z",
    importedBy: "entity-db-cli",
  },
};
